import styled, { css } from 'styled-components'

export const Container = styled.div`
  ${({ height, width }) => css`
    height: ${height || 'auto'};
    width: ${width || 'auto'};
  `}
`
